import { render } from "./Assortment.vue?vue&type=template&id=49abd6fc&scoped=true"
import script from "./Assortment.vue?vue&type=script&lang=js"
export * from "./Assortment.vue?vue&type=script&lang=js"

import "./Assortment.vue?vue&type=style&index=0&id=49abd6fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49abd6fc"]])

export default __exports__